export const LOCALE = {
  FINNISH: 'fi',
  ENGLISH: 'en',
}

export const DOWNLOAD_TYPE = {
  ZIP: 'ZIP',
  LIST: 'LIST',
}
